import { Modal } from 'bootstrap';

/**
 * Nie udało się utworzyć zamówienia w PayU (odpowiedź 503 z /api/application).
 *
 * Domyślna obsługa błędów w `ajax-form.js` pokazuje `alert()` — systemowy popup przeglądarki,
 * który przy awarii operatora płatności wygląda jak awaria strony. Zamiast tego otwieramy ten
 * sam ostylowany komponent, którego używamy dla wyników powrotu z PayU.
 *
 * Reagujemy WYŁĄCZNIE na 503, czyli jedyny status, którym kontroler sygnalizuje niedostępność
 * operatora. Błędy walidacji (400) mają zostać przy polach formularza, a nie w modalu.
 */
$('.registration-form').on('submit-error', function (event, xhr) {
    if (xhr.status !== 503) {
        return;
    }

    const el = document.getElementById('registrationPayuModal');
    if (!el) {
        return;
    }

    // Zatrzymujemy domyślny `alert()` z ajax-form.js dopiero gdy mamy czym go zastąpić.
    event.preventDefault();
    Modal.getOrCreateInstance(el).show();
});
